(function ($) {
  'use strict';

  let scrollActivationPos = 35.2;

  function addStickyStyles() {
    $('div[data-sitewide-alert]').css('display', 'none');
    $('.top-line--wrapper').css('display', 'none');
    $('.region-header').css('position', 'fixed');
    $('.region-header__content').css('height', '5rem');
    $('.region-header__content .block-system-branding-block__content img').css({
      width: '11.875rem', top: '1.4rem'
    });
    $('html').css('paddingTop', '6.3125rem');
  }

  function removeStickyStyles() {
    $('div[data-sitewide-alert]').attr('style', '');
    $('.top-line--wrapper').attr('style', '');
    $('.region-header').attr('style', '');
    $('.region-header__content').attr('style', '');
    $('.region-header__content .block-system-branding-block__content img').attr('style', '');
    $('html').attr('style', '');
  }

  $(window).scroll(function () {
    if ($(document).scrollTop() > scrollActivationPos && window.innerWidth >= window.mobileBreakpoint) {
      addStickyStyles();
    }
    else {
      removeStickyStyles();
    }
  });

  $(window).resize(function () {
    if (window.innerWidth >= window.mobileBreakpoint && $(document).scrollTop() > scrollActivationPos) {
      addStickyStyles();
    }
    else {
      removeStickyStyles();
    }
  });

})(jQuery);
